import {
  Dic
} from '$utils'
export const workingOptions = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: false,
    index: false,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '450px',
    labelWidth: '100px',
    labelPosition: 'right',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    menu: false,
    column: [{
      label: '唯一标识号',
      prop: 'thirdDeviceId',
      search: false,
      hide: false,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      span: 12,
      align: 'center',
      type: 'datetimerange'
    },
    {
      label: '运行状态',
      prop: 'statusDesc',
      search: true,
      align: 'center',
      type: 'select',
      overHidden: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      dicData: Dic.find('SENU004004'),
      span: 12,
    },
    // {
    //   label: '系统类型',
    //   prop: 'deviceMark',
    //   search: false,
    //   addDisplay: false,
    //   editDisplay: false,
    //   viewDisplay: false,
    //   editDisabled: false,
    //   overHidden: true,
    //   align: 'center',
    //   span: 12,
    //   type: 'select',
    //   dicData: Dic.find('SENU087'),
    //   viewFormatter: (row, value) => {
    //     if (value) {
    //       return Dic.findByValue('SENU087', Number(value))
    //     }
    //     return ''
    //   },
    //   formatter: function (row, value) {
    //     return value ? Dic.findByValue('SENU087', value) : ''
    //   },
    // },
    // {
    //   label: '系统地址',
    //   prop: 'parentMac',
    //   search: false,
    //   hide: false,
    //   addDisplay: false,
    //   editDisplay: false,
    //   viewDisplay: false,
    //   span: 12,
    // },
    // {
    //   label: '类型标志',
    //   prop: 'typeMark',
    //   search: false,
    //   addDisplay: false,
    //   editDisplay: false,
    //   viewDisplay: false,
    //   editDisabled: false,
    //   overHidden: true,
    //   align: 'center',
    //   span: 12,
    // },
    // {
    //   label: '回路',
    //   prop: 'loop',
    //   search: false,
    //   overHidden: true,
    //   addDisplay: false,
    //   editDisplay: false,
    //   viewDisplay: false,
    //   align: 'right',
    //   span: 12,
    // },
    {
      label: '部件类型',
      prop: 'subDeviceMark',
      search: false,
      overHidden: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      align: 'right',
      type: 'select',
      span: 12,
      dicData: Dic.find('SENU094'),
      viewFormatter: (row, value) => {
        if (value) {
          return Dic.findByValue('SENU094', Number(value))
        }
        return ''
      },
      formatter: function (row, value) {
        return value ? Dic.findByValue('SENU094', value) : ''
      },
    },
    {
      label: '部件地址',
      prop: 'subDeviceMac',
      search: false,
      overHidden: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      align: 'right',
      span: 12,
    },
    {
      label: '部件说明',
      prop: 'subDeviceDesc',
      search: false,
      overHidden: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      align: 'right',
      span: 12,
    },
    {
      label: '时间',
      prop: 'recordTime',
      search: false,
      overHidden: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      align: 'right',
      span: 12,
    },

    {
      label: '上报码流',
      prop: 'data',
      search: false,
      overHidden: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      align: 'right',
      span: 12,
    },
    ]
  }
}